import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import React, { useState, useRef, useEffect } from 'react';
import styled, { css } from 'styled-components';
import { useLocation, useHistory } from 'react-router';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import { getAssetIcon } from 'utils/icons';
import getContentItemType, { getContentItemTypeTranslationKey } from 'utils/asset/getContentItemType';
import { pxToRem, pxToEm } from 'utils/ui/units';
import { englifySearchValue, localiseSearchValue } from 'utils/search/translateSearchProps';
import ToolbarButton from 'components/ToolbarButton';
import useOnNavigateAway from 'hooks/useOnNavigateAway';
import { Combobox, ComboboxInput, ComboboxMenu, ComboboxMenuItem } from 'components/Combobox';
import Flex, { Box } from 'components/Flex';
import VisuallyHidden from 'components/VisuallyHidden';
import SearchBox from 'components/SearchBox';
import { spacing, breakpoints, maxPageWidth } from 'styles/globals';
import { useDebounce } from 'use-debounce';
import { useFetchMySearchContent } from 'actions/content';
import useFetchList from 'actions/useFetchList';
var SearchOverlay = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(prop) {
    return !['isSearchOpen', 'height'].includes(prop);
  }
}).withConfig({
  displayName: "searchForm__SearchOverlay",
  componentId: "sc-6ingy2-0"
})(["position:absolute;top:50%;left:0;display:flex;align-items:center;width:100%;height:", ";padding-left:", ";transition:opacity 250ms linear 200ms;will-change:opacity,transform;@media (min-width:", "){top:0;left:auto;right:0;width:40%;}@media (min-width:", "){width:", ";right:calc((100% - ", ") / 2);}", " & > *{width:100%;}"], function (p) {
  return p.height ? pxToRem(p.height) : '100%';
}, spacing.s, breakpoints.s, pxToEm(maxPageWidth, 16), pxToRem(maxPageWidth * 0.4), pxToRem(maxPageWidth), function (p) {
  return !p.isSearchOpen && css(["opacity:0;transform:translateY(-200%);transition-delay:0s;"]);
});
var DEBOUNCE_INTERVAL = 300;
function useSearchSuggestions(searchValue) {
  var _useDebounce = useDebounce(searchValue, DEBOUNCE_INTERVAL),
    _useDebounce2 = _slicedToArray(_useDebounce, 1),
    debouncedSearchValue = _useDebounce2[0];
  var debouncedEngSearchValue = englifySearchValue(debouncedSearchValue);
  var searchContent = useFetchMySearchContent({
    searchValue: debouncedEngSearchValue,
    limit: 5
  });
  var searchTerms = useFetchList('me/content/searchTerms', {
    query: debouncedEngSearchValue,
    limit: 5
  });
  var searchSuggestions = searchTerms.items.map(function (_ref) {
    var value = _ref.value;
    return {
      value: value,
      type: 'search',
      name: value,
      id: value
    };
  });

  // Remove search terms when there is content to show too
  // This is adaptive, i.e. if there is only one search term, we show 4 content items
  // If there are 2 search terms, we show 3 content items, etc.
  // It however there are 5 search terms and 1 content items, we show 4 search terms and the 1 content item
  searchSuggestions = searchSuggestions.slice(0, Math.min(searchSuggestions.length, 5 - Math.min(searchContent.items.length, 3)));

  // Translate search suggestions keys
  searchSuggestions = searchSuggestions.map(function (suggestion) {
    return _objectSpread(_objectSpread({}, suggestion), {}, {
      name: localiseSearchValue(suggestion.value)
    });
  });
  var items = [].concat(_toConsumableArray(searchContent.items.splice(0, 5)), _toConsumableArray(searchSuggestions));
  return {
    items: items,
    isLoading: searchTerms.isLoading || searchContent.isLoading
  };
}
function getPlaylistIdFromLocation(_ref2) {
  var pathname = _ref2.pathname;
  if (pathname.startsWith('/playlist')) {
    var urlSegments = pathname.split('/');
    return Number(urlSegments.at(-1));
  }
}
function getA11yStatusMessage(_ref3) {
  var resultCount = _ref3.resultCount;
  // The first menu item just represents the user's
  // input, not a search suggestion, so we subtract it
  var count = resultCount - 1;
  if (!count) {
    return i18n.t('no_search_suggestions_found');
  }
  if (count > 0) {
    return i18n.t('search_navigation_available_suggestions', {
      count: count
    });
  }
  return '';
}
function SearchForm(_ref4) {
  var isOpen = _ref4.isOpen,
    onOpen = _ref4.onOpen,
    onClose = _ref4.onClose,
    searchInputRef = _ref4.searchInputRef,
    height = _ref4.height;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var wrapperRef = useRef(null);
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    searchValue = _useState2[0],
    setSearchValue = _useState2[1];
  var trimmedSearchValue = searchValue.trim();
  var location = useLocation();
  var pathname = location.pathname;
  var history = useHistory();
  var playlistId = getPlaylistIdFromLocation(location);
  var _useSearchSuggestions = useSearchSuggestions(trimmedSearchValue),
    menuItems = _useSearchSuggestions.items,
    isLoading = _useSearchSuggestions.isLoading;

  // Close search when it is empty and user focus
  // is moved outside of the search panel
  var shouldCloseWhenNavigatingAway = isOpen && trimmedSearchValue === '';
  useOnNavigateAway(wrapperRef, onClose, shouldCloseWhenNavigatingAway);

  // Close & clear search when navigating to any page
  // but the search or playlists page
  useEffect(function () {
    if (!pathname.startsWith('/search') && !pathname.startsWith('/playlists')) {
      onClose();
      setSearchValue('');
    }
  }, [pathname, onClose]);
  function clearSearch() {
    var _searchInputRef$curre;
    setSearchValue('');
    (_searchInputRef$curre = searchInputRef.current) === null || _searchInputRef$curre === void 0 ? void 0 : _searchInputRef$curre.focus();
  }
  function selectSuggestion(selected) {
    var value = selected.value;
    if (value === trimmedSearchValue || value === undefined) {
      history.push(createLocation('/search', {
        term: englifySearchValue(trimmedSearchValue)
      }));
      return;
    }
    var selectedItem = menuItems.find(function (item) {
      return item.id === value;
    });
    if (!selectedItem) {
      return;
    }
    if (selectedItem.type === 'playlist') {
      history.push("/playlists/".concat(selectedItem.id));
    } else if (selectedItem.type === 'topic') {
      history.push("/browse/".concat(selectedItem.id));
    } else if ('value' in selectedItem && selectedItem.value) {
      history.push("/search?term=".concat(selectedItem.value));
    } else {
      history.push(createLocation(location.pathname, {
        asset: selectedItem.id
      }));
    }
  }

  // Submit search when the dropdown menu isn't open
  function submitSearch(e) {
    e.preventDefault();
    if (trimmedSearchValue.length === 0) {
      return null;
    }
    history.push(createLocation('/search', {
      term: trimmedSearchValue
    }));
  }

  // On mount, check for a search term query parameter
  // & populate the search field if one is present
  useEffect(function () {
    var _queryparse = queryparse(location.search),
      term = _queryparse.term;
    if (term) {
      setSearchValue(localiseSearchValue(term));
      onOpen();
    }
  }, [onOpen, location.search]);
  return /*#__PURE__*/React.createElement(SearchOverlay, {
    ref: wrapperRef,
    height: height,
    isSearchOpen: isOpen,
    "aria-hidden": isOpen ? undefined : true
  }, /*#__PURE__*/React.createElement(Flex, {
    role: "search"
  }, /*#__PURE__*/React.createElement(Box, {
    grow: true,
    shrink: true,
    as: "form",
    onSubmit: submitSearch
  }, /*#__PURE__*/React.createElement(Combobox, {
    inputValue: searchValue
    // Add 1 to account for the static first menu item
    ,
    resultCount: menuItems.length + 1,
    onSelect: selectSuggestion,
    onInputChange: function onInputChange(e) {
      return setSearchValue(e.target.value);
    },
    getStatusMessage: getA11yStatusMessage,
    canOpenMenu: Boolean(isOpen && trimmedSearchValue.length),
    id: "main-search"
  }, /*#__PURE__*/React.createElement(ComboboxInput
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  , {
    inverted: true,
    transparent: true,
    as: SearchBox,
    refKey: "wrapperRef",
    inputRef: searchInputRef,
    label: t('navbar_search'),
    isSearching: isLoading,
    tabIndex: isOpen ? 0 : -1
  }), /*#__PURE__*/React.createElement(ComboboxMenu, {
    "aria-label": t('search_suggestions')
  }, /*#__PURE__*/React.createElement(ComboboxMenuItem, {
    key: "search-input",
    icon: "search",
    value: trimmedSearchValue
  }, t('search_results_view_all', {
    searchInput: trimmedSearchValue
  })), menuItems.map(function (item) {
    var isDisabled = playlistId ? playlistId === item.id : false;
    var assetType = item.type && getContentItemType(item);
    return /*#__PURE__*/React.createElement(ComboboxMenuItem, {
      key: item.id,
      icon: getAssetIcon(item),
      value: item.id,
      text: item.name,
      isDisabled: isDisabled
    }, assetType && /*#__PURE__*/React.createElement(VisuallyHidden, null, t(getContentItemTypeTranslationKey(assetType))), item.name);
  })))), /*#__PURE__*/React.createElement(Box, null, /*#__PURE__*/React.createElement(ToolbarButton, {
    icon: "x",
    title: searchValue ? t('actions_clear_search') : t('actions_close_search'),
    onClick: searchValue ? clearSearch : onClose,
    tabIndex: isOpen ? 0 : -1
  }))));
}
export default SearchForm;